/* Noén: quiet interactions (scroll reveal, press rotator, hover video). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var items = (root || document).querySelectorAll('.nn-reveal:not(.is-visible)');
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 40% 0px', threshold: 0 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initHoverVideos(root) {
    (root || document).querySelectorAll('.nn-card').forEach(function (card) {
      var v = card.querySelector('video.nn-card__hover');
      if (!v || card.dataset.nnVideo) return;
      card.dataset.nnVideo = '1';
      card.addEventListener('mouseenter', function () { v.style.opacity = 1; var p = v.play(); if (p) p.catch(function () {}); });
      card.addEventListener('mouseleave', function () { v.style.opacity = 0; v.pause(); });
    });
  }

  if (!customElements.get('noen-press')) {
    customElements.define('noen-press', class extends HTMLElement {
      connectedCallback() {
        this.quotes = Array.from(this.querySelectorAll('.nn-press__quote'));
        this.logos = Array.from(this.querySelectorAll('.nn-press__logo[data-index]'));
        this.index = 0;
        this.logos.forEach((b) => b.addEventListener('click', () => { this.show(parseInt(b.dataset.index, 10)); this.restart(); }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      show(i) {
        this.index = i;
        this.quotes.forEach((q, n) => q.classList.toggle('is-active', n === i));
        this.logos.forEach((l) => l.classList.toggle('is-active', parseInt(l.dataset.index, 10) === i));
      }
      stop() { clearInterval(this.timer); }
      restart() {
        this.stop();
        if (reduce || this.quotes.length < 2) return;
        var ms = parseInt(this.dataset.interval, 10) || 6000;
        this.timer = setInterval(() => this.show((this.index + 1) % this.quotes.length), ms);
      }
    });
  }

  /* Gentle drift for collage images while scrolling (AYOND-style). */
  function initDrift() {
    if (reduce) return;
    var stages = Array.prototype.slice.call(document.querySelectorAll('.nn-collage__stage'));
    if (!stages.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      stages.forEach(function (st) {
        var r = st.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh; /* -1..1 around centre */
        st.querySelectorAll('.nn-collage__item').forEach(function (it, i) {
          var z = parseFloat(getComputedStyle(it).getPropertyValue('--z')) || 1;
          var speed = (i % 2 ? -1 : 1) * (10 + z * 8);
          it.style.setProperty('--nn-drift', (p * speed).toFixed(1) + 'px');
        });
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initBotAuto(root) {
    if (reduce) return;
    (root || document).querySelectorAll('.nn-bot__track').forEach(function (tr) {
      if (tr._nnAuto) return; tr._nnAuto = true;
      var items = tr.querySelectorAll('.nn-bot__item'); if (items.length < 2) return;
      var i = 0, hold = false;
      tr.addEventListener('pointerenter', function () { hold = true; });
      tr.addEventListener('pointerleave', function () { hold = false; });
      tr.addEventListener('touchstart', function () { hold = true; }, { passive: true });
      setInterval(function () {
        if (hold || document.hidden) return;
        var r = tr.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
        i = (Math.round(tr.scrollLeft / items[0].offsetWidth) + 1) % items.length;
        tr.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
      }, 3500);
    });
  }

  function init(root) { initReveal(root); initHoverVideos(root); initBotAuto(root); if (!root) initDrift(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Ritual steps: arrows + counter */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.nn-ritual__steps').forEach(function (wrap) {
      if (wrap.dataset.nnInit) return; wrap.dataset.nnInit = '1';
      var track = wrap.querySelector('.nn-ritual__track'); var cur = wrap.querySelector('[data-current]');
      if (!track) return;
      function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
      wrap.querySelectorAll('.nn-ritual__arrow').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = track.children.length; var i = (idx() + parseInt(b.dataset.dir, 10) + n) % n;
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { if (cur) cur.textContent = idx() + 1; }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Gallery lightbox */
(function () {
  if (customElements.get('noen-lightbox')) return;
  customElements.define('noen-lightbox', class extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.nn-gallery__open'));
      this.box = this.closest('section').querySelector('.nn-lightbox');
      if (!this.box) return;
      this.img = this.box.querySelector('.nn-lightbox__img');
      this.items.forEach((b, i) => b.addEventListener('click', () => this.open(i)));
      this.box.querySelector('.nn-lightbox__close').addEventListener('click', () => this.close());
      this.box.querySelector('.nn-lightbox__prev').addEventListener('click', () => this.go(-1));
      this.box.querySelector('.nn-lightbox__next').addEventListener('click', () => this.go(1));
      this.box.addEventListener('click', (e) => { if (e.target === this.box) this.close(); });
      this.onKey = (e) => {
        if (this.box.hidden) return;
        if (e.key === 'Escape') this.close(); if (e.key === 'ArrowLeft') this.go(-1); if (e.key === 'ArrowRight') this.go(1);
      };
      document.addEventListener('keydown', this.onKey);
    }
    disconnectedCallback() { document.removeEventListener('keydown', this.onKey); }
    open(i) { this.i = i; this.show(); this.box.hidden = false; document.documentElement.style.overflow = 'hidden'; this.lastFocus = document.activeElement; this.box.querySelector('.nn-lightbox__close').focus(); }
    close() { this.box.hidden = true; document.documentElement.style.overflow = ''; if (this.lastFocus) this.lastFocus.focus(); }
    go(d) { this.i = (this.i + d + this.items.length) % this.items.length; this.show(); }
    show() { const b = this.items[this.i]; this.img.src = b.dataset.full; this.img.alt = b.dataset.alt || ''; }
  });
})();

/* v16: show whole-dollar prices as $42 (the subscription app writes $42.00) */
(function(){var p=document.querySelector('.product-info');if(!p)return;var re=/^(\s*[$€£]\d[\d,]*)\.00(\s*)$/;function fix(){var w=document.createTreeWalker(p,NodeFilter.SHOW_TEXT),n;while((n=w.nextNode())){if(re.test(n.nodeValue))n.nodeValue=n.nodeValue.replace(re,'$1$2');}}fix();new MutationObserver(fix).observe(p,{subtree:true,childList:true,characterData:true});})();